import React, { useEffect, useState } from 'react'
import './MintModal.css'
import { smartContractAddress } from '../../config'
import { int2hex } from '../../helpers/encoding'
import { fetchQueryHex, fetchWhitelistData } from '../../helpers/sqQueries'
import BigNumber from 'bignumber.js'
import { U64Value } from '@elrondnetwork/erdjs/out'
import {
    logout,
    transactionServices,
    useGetAccountInfo,
    refreshAccount,
    DappUI,
} from '@elrondnetwork/dapp-core'
import { Balance } from '@elrondnetwork/erdjs/out'
import { routeNames } from 'routes'
import LoginComponent from 'components/Connect'
import { useModalDisableScroll } from 'helpers/hooks'

export default function MintModal({ children, shown, close }) {
    useModalDisableScroll(shown)

    const baseGasLimit = 50_000_000
    const [maxTokens, setMaxTokens] = useState(5)
    const [price, setPrice] = useState(0.69)
    const [howManyTokens, setHowManyTokens] = useState(maxTokens)
    const [didMount, setDidMount] = useState(false)
    const { address, account } = useGetAccountInfo()

    const loggedIn = Boolean(address)
    function checkHowMany(newNumber) {
        if (parseInt(newNumber) > maxTokens) {
            setHowManyTokens(maxTokens)
        } else if (newNumber < 1) {
            setHowManyTokens('')
        } else {
            setHowManyTokens(newNumber)
        }
    }

    const { sendTransactions } = transactionServices
    const mintFunction = async () => {
        const mintTransaction = {
            value: getPrice().toString(),
            data: `buy@01@${int2hex(parseInt(howManyTokens))}`,
            // gasLimit: 30_000_000 + ((howManyTokens - 1) * 20_000_000),
            value: Balance.egld(getPrice()), //getNominatedPrice().toString(),
            receiver: smartContractAddress,
            gasLimit: baseGasLimit + 12_000_000 * (howManyTokens - 1),
        }
        console.log(mintTransaction.value)
        await refreshAccount()

        const { sessionId /*, error*/ } = await sendTransactions({
            transactions: mintTransaction,
            transactionsDisplayInfo: {
                processingMessage: 'Processing transaction',
                errorMessage: 'An error has occured during minting',
                successMessage: 'Transaction successful',
                transactionDuration: 10000,
            },
        })
        if (sessionId != null) {
            console.log('session id: ' + sessionId)
        }
    }

    useEffect(() => {
        if (!loggedIn || didMount) return
        Promise.all([
            fetchWhitelistData(address),
            fetchQueryHex(
                'remainingMints',
                [new U64Value(new BigNumber(1))],
                smartContractAddress
            ),
        ]).then(([whitelistData, remainingHex]) => {
            console.log(whitelistData)
            if (whitelistData.isWhitelisted) {
                if (whitelistData.remainingFreeMints > 0) {
                    setPrice(0)
                    setMaxTokens(whitelistData.remainingFreeMints)
                    setHowManyTokens(
                        getMaxPurchasable(whitelistData.remainingFreeMints)
                    )
                } else {
                    setPrice(
                        parseFloat(whitelistData.price) /
                            1_000_000_000_000_000_000
                    )
                    setMaxTokens(whitelistData.remainingWhitelistBuyingQty)
                    setHowManyTokens(
                        getMaxPurchasable(
                            whitelistData.remainingWhitelistBuyingQty
                        )
                    )
                }
            } else {
                setPrice(
                    parseFloat(whitelistData.price) / 1_000_000_000_000_000_000
                )
                setMaxTokens(whitelistData.remainingPublicBuyingQty)
                setHowManyTokens(
                    getMaxPurchasable(whitelistData.remainingPublicBuyingQty)
                )
            }
        })
        setDidMount(true)
    }, [loggedIn])

    const getPrice = () => {
        return parseFloat(parseFloat(price * howManyTokens).toFixed(5))
    }

    const getPriceDiff = () => {
        return Math.abs(
            Math.round(account.balance / 1_000_000_000_000_000) / 1000 -
                (getPrice() + 0.001)
        )
    }

    const getFormattedPriceDiff = () => {
        return parseFloat(getPriceDiff().toFixed(5)).toString()
    }

    const getMaxPurchasable = (maxAvailable) => {
        if (!loggedIn) return 0
        let balance = account.balance / 1_000_000_000_000_000_000
        balance = 0.1
        let maxPurchasable = Math.floor(balance / price)
        return maxPurchasable > maxAvailable ? maxAvailable : maxPurchasable
    }

    const {
        ExtensionLoginButton,
        WebWalletLoginButton,
        LedgerLoginButton,
        WalletConnectLoginButton,
    } = DappUI

    const login = (
        <div>
            <ExtensionLoginButton
                callbackRoute={routeNames.home}
                loginButtonText={'Extension'}
            />
            <WebWalletLoginButton
                callbackRoute={routeNames.home}
                loginButtonText={'Web wallet'}
            />
            <LedgerLoginButton
                loginButtonText={'Ledger'}
                callbackRoute={'asdfasawdawd'}
            />
            <WalletConnectLoginButton
                callbackRoute={routeNames.home}
                loginButtonText={'Maiar'}
            />
        </div>
    )

    return shown ? (
        <div
            className="mintmodal-backdrop"
            onClick={() => {
                close()
            }}
        >
            <div
                className={
                    true ? 'mintmodal-contentConnect' : 'mintmodal-content'
                }
                onClick={(e) => {
                    e.stopPropagation()
                }}
            >
                <h1>mint some lunicorns</h1>
                {maxTokens > 0 && !loggedIn && login}
                {!loggedIn && maxTokens > 0 && (
                    <h3>connect wallet above to mint lunicorns!</h3>
                )}
                {loggedIn && maxTokens > 0 && (
                    <h3>
                        input number of lunicorns to mint ({getPrice()} egld)
                    </h3>
                )}
                {loggedIn && maxTokens > 0 && (
                    <input
                        type="number"
                        min="1"
                        max={maxTokens}
                        value={howManyTokens}
                        onChange={(e) => checkHowMany(e.target.value)}
                        name=""
                    />
                )}
                {account.balance / 1_000_000_000_000_000_000 <= getPrice() && (
                    <h3>
                        You need {getFormattedPriceDiff()} more egld to mint{' '}
                        {howManyTokens} lunicorn(s)!
                    </h3>
                )}
                {loggedIn &&
                    maxTokens > 0 &&
                    // && (account.balance / 1_000_000_000_000_000_000) > getPrice()
                    howManyTokens > 0 && (
                        <button
                            onClick={mintFunction}
                            className="mintmodal__mintButton"
                        >
                            mint {howManyTokens} lunicorn(s)!
                        </button>
                    )}
                {maxTokens == 0 && (
                    <h2 className="mt-4 mb-5">
                        No more Lunicorns to mint yet..
                    </h2>
                )}
                <button
                    onClick={(e) => {
                        close(e)
                    }}
                    className={'okButton mt-5'}
                >
                    close
                </button>
            </div>
        </div>
    ) : null
}
